<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-0 bg-logo"
        style="background-color:#3f3939;"
      />

      <b-col
        lg="4"
        class="auth-bg px-2 p-lg-5"
        style="display: grid;"
      >

        <div style="margin-top: 10rem;">
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
            style="font-size: 1.438rem;"
          >
            Prezado, confirme a dispensa da notificação!
          </b-card-title>
          <!-- form -->
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent
          >
            <!-- email -->
            <b-form-group
              label="Selecione seu e-mail"
              label-for="login-email"
            >
              <b-form-select
                v-model="emailSelected"
                :options="emails"
                :disabled="emails.length == 0 || dispensado"
              />
            </b-form-group>

            <b-alert
              v-if="dispensado"
              show
              variant="danger"
              class="alert-danger"
            />

            <!-- submit buttons -->
            <b-btn
              :variant=" !dispensado? 'primary' : 'success'"
              :disabled="emails.length == 0 || dispensado"
              style="margin-bottom: 1rem;"
              block
              @click="dispensaNotificacao"
            >
              {{ dispensado? "Dispensa confirmada!" : "Confirmar dispensa" }}
            </b-btn>
            <span
              v-if="!dispensado"
              style="color: red;"
            >
              Importante: após confirmar a dispensa não será enviado novas notificações desse certificado em vencimento.
            </span>
          </b-form>
        </div>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>

<script>
/* eslint-disable global-require */

import api from '@/app-modulo/comuns/leading-pages/externo/service/api'
import { getUserData } from '@/auth/utils'

export default {
  components: {
  },
  data() {
    return {
      form: {
        token: this.$route.query.token,
        certificadoId: this.$route.query.certificadoId,
      },
      dispensado: false,
      loginError: '',
      required: true,
      emails: [],
      emailSelected: null,
    }
  },
  created() {
    this.getDadosDispensarNotificacaoCertificados()
  },
  methods: {
    getDadosDispensarNotificacaoCertificados() {
      api.getDadosDispensaNotificacaoCertificado(getUserData().id)
        .then(response => {
          this.dispensado = response.data.dispensado
          this.emailSelected = response.data.usuarioDispensouNotificacaoCerficado
          this.emails = this.dispensado ? [this.emailSelected] : response.data.socioEmails
        })
    },
    dispensaNotificacao() {
      if (!this.emailSelected) {
        this.$erro('Favor selecionar um email')
        this.dispensado = false
      } else {
        api.dispensaNotificacao(getUserData().id, this.emailSelected)
          .then(() => {
            this.$sucesso('Aviso dispensado com sucesso!')
            this.dispensado = true
          })
          .catch(err => {
            this.$erro('Não foi possivel dispensa o aviso de vencimento do certificado.')
            throw err
          })
      }
    },
    responsavelPelaDispensa() {
      api.dispensaNotificacao()
        .then(() => {
          this.$sucesso('Aviso dispensado com sucesso!')
          this.dispensado = true
        })
        .catch(err => {
          this.$erro('Não foi possivel dispensa o aviso de vencimento do certificado.')
          throw err
        })
    },

  },
}
</script>
